<template lang="pug">
  .page
    header-section(title="LEI Search")
      //.help-block(v-if="!expertMode")
        //lei-popover(:text="tooltips.resetSearch")
        h3.title.default-bold Do you need help getting started?
        p.tip.w-3.default Try one of these frequently used searches
        a.example.w-4(@click="searchByOwns") Who owns
          a.default-bold  ...
          |  ?
        a.example.w-4(@click="searchOwnedBy") What is owned by
          a.default-bold  ...
          |  ?
    //section.new-section.align-center(v-if="showNewLine")
      notice-block(:info="newInfo",
      title="new",
      link="Learn more",
      @close="closeNewLine")
    search-form
    search-modals
    router-view
</template>
<script>
import HeaderSection from '../components/layout-components/HeaderSection'
import SearchForm from '../components/search-components/SearchForm'
import Loading from '../components/lei-components/Loading'
import { mapActions, mapMutations, mapState, } from 'vuex'
import qs from 'qs'
import { SET_ALL, SET_FULLTEXT_FILTER, } from '../store/modules/search/mutations-types'
import routerSearch from '../mixins/router-search-mixin'
import goToSearch from '../mixins/go-to-search'
import NoticeBlock from '../components/lei-components/NoticeBlock'
import { CLOSE_NEW_LINE, } from '../store/mutations-types'
import LeiPopover from '../components/lei-components/LeiPopover'
import simple from '../constants/tooltips/simple'
import { findFilterById, } from '../store/modules/search/helpers'
import { urlSpecialCharDecoder, } from '../utils/urlSpecialCharHandlers'
import SearchModals from '@/components/search-components/SearchModals.vue'
import LeiInfoLabel from '@/components/lei-components/LeiInfoLabel'


export default {
  components: {
    NoticeBlock,
    SearchForm,
    Loading,
    HeaderSection,
    LeiPopover,
    SearchModals,
    LeiInfoLabel,
  },
  mixins: [ routerSearch, goToSearch, ],
  data () {
    return {
      newInfo: `Our LEI Search now also includes LEVEL 2 DATA
        including lorem ipsum dolor sit text and more.`,
      tooltips: simple,
    }
  },
  computed: {
    ...mapState([ 'showNewLine', ]),
    ...mapState('search', [
      'showResults',
      'expertMode',
      'loading',
      'filters',
    ]),
  },
  created () {
    this.getAllData()
  },
  beforeRouteUpdate (to, from, next) {
    this.getAllData()
    next()
  },
  methods: {
    setAndScroll (filterId) {
      this.setFulltextFilter(findFilterById(this.filters, filterId))
      this.goToSearch()
    },
    searchByOwns () {
      this.setAndScroll('LEIREC_OWNS_AUTOCOMPLETE')
    },
    searchOwnedBy () {
      this.setAndScroll('LEIREC_OWNED_BY_AUTOCOMPLETE')
    },
    getAllData () {
      this.getFilters()
        .then(() => {
          this.setAll(qs.parse(this.$route.params.search, {
            depth: Infinity,
            decoder: urlSpecialCharDecoder,
          }))
          this.searchWithParams()
        })
    },

    ...mapMutations({
      closeNewLine: CLOSE_NEW_LINE,
    }),
    ...mapMutations('search', {
      setFulltextFilter: SET_FULLTEXT_FILTER,
      setAll: SET_ALL,
    }),
    ...mapActions('search', [ 'getFilters', ]),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../assets/styles/variables.styl"

  .new-section
    width 85%
    min-width 1000px

  .help-block
    min-width 370px
    padding 10px 20px
    border 2px solid $default-color-light-1
    border-radius 5px
    min-height 150px
    height fit-content
    display flex
    flex-direction column
    justify-content space-around
    align-items flex-start
    .title
      font-size 1.1rem
    .tip
      font-size 0.8rem
      margin 15px 0
    .example
      color $default-color-bold
      font-size 0.9rem
      line-height 1.4rem
      display inline-block
      border-bottom 2px solid $info-color

  @media (max-width: $laptop)
    .new-section
      width 100%
      min-width auto

    .help-block
      min-width auto
      padding 30px 20px
      border none
      border-bottom 1px solid $default-color-light-1
      border-radius 0

</style>



// WEBPACK FOOTER //
// src/pages/SearchPage.vue